<template lang="pug">
    div.range-slider-control
        range-slider(:value='value' :min='min' :max='max' :step='step'
                @input='input' @change='change')
        div.range-slider-control__slider-value {{ value.toFixed(2) }}
</template>

<script>
import RangeSlider from 'vue-range-slider'
import 'vue-range-slider/dist/vue-range-slider.css'

export default {
    name: 'range-slider-control',
    components: {
        RangeSlider,
    },
    props: {
        value: {
            type: Number,
            required: true,
        },
        min: {
            type: Number,
        },
        max: {
            type: Number,
        },
        step: {
            type: Number,
        },
    },
    methods: {
        input(val) {
            this.$emit('input', val)
        },
        change(val) {
            this.$emit('change', val)
        },
    },
}
</script>
